import {PricingModel} from 'src/openapi/admin/models/PricingModel';

export const PRICING_MODEL_LABEL = {
    [PricingModel.SUBSCRIPTION]: 'Subscription',
    [PricingModel.PAY_PER_CALL]: 'Pay-per-Call',
    [PricingModel.INTEGRATION]: 'Integration',
};
